<div class="main-header">
  <div class="menu-toggle" (click)="toggleSidebar()">
    <div></div>
    <div></div>
    <div></div>
  </div>
  <div class="logo">
    <img src="./assets/images/logo-aar-horizontal-branco-ciano.png" height="24px" />
  </div>

  <div style="margin: auto"></div>

  <div class="header-part-right buttons" *ngIf="!(isAuthenticated$ | async)">
    <div class="row">
      <div class="col">
        <a [routerLink]="['/sign-up']" routerLinkActive="router-link-active"
          class="btn btn-primary btn-rounded btn-block">CRIAR CONTA</a>
      </div>
      <div class="col">
        <a [routerLink]="['/login']" class="btn btn-outline-secondary btn-rounded btn-block">ENTRAR</a>
      </div>
    </div>
  </div>

  <div class="header-part-right" *ngIf="isAuthenticated$ | async">
    <div ngbDropdown [placement]="'bottom-right'">
      <div class="badge-top-container">
        <span class="badge badge-primary">{{notifications.length}}</span>
        <i ngbDropdownToggle class="material-icons header-icon" role="button">notifications</i>
      </div>
      <div ngbDropdownMenu class="notification-dropdown rtl-ps-none" perfectScrollbar>
        <div class="dropdown-item d-flex" *ngFor="let item of notifications" [routerLink]="[item.link]">
          <div class="notification-icon">
            <i class="{{item.icon}} text-{{item.status}} mr-1"></i>
          </div>
          <div class="notification-details flex-grow-1">
            <p class="m-0 d-flex align-items-center">
              <span>{{item.title}}</span>
              <span *ngIf="item.badge" class="badge badge-pill badge-{{item.status}} ml-1 mr-1">{{item.badge}}</span>
              <span class="flex-grow-1"></span>
              <span class="text-small text-muted ml-auto">{{item.time | date: 'dd/MM/yyyy'}}</span>
            </p>
            <p class="text-small text-muted m-0">{{item.text | excerpt:30}}</p>
          </div>
        </div>
      </div>
    </div>

    <div ngbDropdown [placement]="'bottom-right'" class="user col">
      <a [routerLink]="['/logout']" class="exit-to-app"><i class="material-icons">exit_to_app</i></a>
      <!-- <span id="userDropdown" ngbDropdownToggle alt="">
        <i class="material-icons header-icon" style="vertical-align:sub;" role="button">person</i>
        <span class="name-user">Olá, {{(userInfo$ | async)?.name}}</span>
      </span>
      <div ngbDropdownMenu aria-labelledby="userDropdown" class="header-account-dropdown">
        <a [routerLink]="['/painel/product']" class="dropdown-item"><i
            class="material-icons">chevron_right</i>Produtos</a>
        <div class="dropdown-divider"></div>
        <a [routerLink]="['/logout']" class="dropdown-item"><i class="material-icons">chevron_right</i>Sair</a>
      </div> -->
    </div>

  </div>

</div>
